module.exports = __webpack_public_path__ + "static/media/cover.2cce0fb8.png";